import type { KeyboardEvent, FocusEvent, MouseEvent, TouchEvent } from 'react';

import { interactionsOverlay } from '../InteractionsOverlay.sty.js';

/**
 * Checks whether an event comes from the HTML element that has the event listener.
 * In case it comes from a child element, returns false.
 * @param event -
 */
export const isOwnEvent = (
  event: MouseEvent | TouchEvent | KeyboardEvent | FocusEvent,
) => {
  const target = event.target as HTMLElement | null;
  return (
    event.currentTarget === target ||
    target?.classList?.contains(interactionsOverlay)
  );
};
